import ReactDOM from 'react-dom/client';
import Modal from 'react-modal';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import App from './App';
import { LanguageProvider } from './hooks/LanguageContext'; // Import LanguageProvider
import { store, persistor } from './store'; // store 파일의 경로에 따라 수정
import { getLanguage } from './utils/languageStorage';

import './index.css';

// 앱 로드 시 저장된 언어로 document lang 동기화 (한영전환 시 날짜 등 UI 일관성)
const savedLang = typeof window !== 'undefined' ? getLanguage() : null;
if (savedLang && document.documentElement) {
  document.documentElement.lang = savedLang === 'ko' ? 'ko' : 'en';
}

// [2026-10-30 X-02] 예전 로그인이 localStorage 에 남긴 비밀번호 정리 — 읽는 곳이 없고 저장도 이제 안 한다
try {
  localStorage.removeItem('admin_password');
} catch (e) {
  // 저장소 접근이 막힌 환경(사생활 보호 모드 등)은 무시
}

// iOS 웹뷰는 <input>에 autocapitalize 속성이 없으면 기본값(sentences)으로 첫 글자를
//  자동 대문자화한다(안드로이드는 이 동작이 없음). 컴포넌트마다 속성을 다는 대신
//  포커스 시점에 전역으로 꺼준다 — 키보드가 뜨기 전(캡처 단계)에 세팅되어야 반영된다.
document.addEventListener(
  'focus',
  event => {
    const el = event.target;
    if (
      (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) &&
      !el.hasAttribute('autocapitalize')
    ) {
      el.setAttribute('autocapitalize', 'off');
    }
  },
  true
);

const rootNode = document.getElementById('root');

// react-modal 접근성(aria-hidden) 대상 지정. 렌더 전 1회.
Modal.setAppElement('#root');

ReactDOM.createRoot(rootNode).render(
  <>
    <LanguageProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </LanguageProvider>
  </>
);
